// extracted by mini-css-extract-plugin
export default {"gameContainer":"game_gameContainer__kcZ5+"};